'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useRef } from 'react'
export const dynamic = 'force-dynamic'

export const PageContent = ({
  html,
  css,
  js,
}: {
  html: string
  css: string
  js: string
}) => {
  const scriptRef = useRef<HTMLScriptElement | null>(null)
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    const executeScript = () => {
      if (scriptRef.current && scriptRef.current.parentNode) {
        return
      }

      const script = document.createElement('script')
      script.text = js
      script.id = 'script-diagnosis'
      document.body.appendChild(script)
      scriptRef.current = script
    }

    executeScript()

    return () => {
      if (scriptRef.current && scriptRef.current.parentNode) {
        scriptRef.current.parentNode.removeChild(scriptRef.current)
      }
    }
  }, [js, pathname, searchParams])

  return (
    <div>
      <style>{css}</style>
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  )
}
